var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_14137_9850)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 30C23.7313 30 30 23.7313 30 16C30 8.26875 23.7313 2 16 2C8.26875 2 2 8.26875 2 16C2 16.65 2.04375 17.2875 2.13125 17.9125L1.53125 18.1313C1.04375 18.3125 0.6125 18.6125 0.2875 19C0.09375 18.0312 0 17.025 0 16C0 7.1625 7.1625 0 16 0C24.8375 0 32 7.1625 32 16C32 24.8375 24.8375 32 16 32C14.975 32 13.9688 31.9062 12.9937 31.7188C13.3812 31.3875 13.6813 30.9625 13.8625 30.475L14.0813 29.875C14.7063 29.9625 15.3438 30.0063 15.9937 30.0063L16 30ZM15.5188 25.9875L16.25 23.9937C20.55 23.8625 24 20.3312 24 16C24 11.5813 20.4188 8 16 8C11.6687 8 8.1375 11.4438 8.00625 15.75L6.0125 16.4813C6.00625 16.3188 6 16.1625 6 16C6 10.475 10.475 6 16 6C21.525 6 26 10.475 26 16C26 21.525 21.525 26 16 26C15.8375 26 15.675 25.9937 15.5188 25.9875ZM16.9375 16.3438L11.9875 29.7812C11.8438 30.1688 11.4813 30.425 11.0688 30.4375C10.6562 30.45 10.2812 30.2 10.125 29.8188L8.21875 25.1938L1.70625 31.7062C1.31875 32.0938 0.68125 32.0938 0.29375 31.7062C-0.09375 31.3187 -0.09375 30.6813 0.29375 30.2938L6.80625 23.7812L2.18125 21.875C1.8 21.7188 1.55625 21.3438 1.5625 20.9312C1.56875 20.5187 1.83125 20.1562 2.21875 20.0125L15.6562 15.0625C16.025 14.925 16.4312 15.0188 16.7062 15.2937C16.9812 15.5687 17.075 15.9812 16.9375 16.3438ZM8.95625 22.5C9.2 22.6 9.4 22.8 9.5 23.0438L11 26.6812L14.3125 17.6875L5.31875 21L8.95625 22.5Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14137_9850"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1);
export default __webpack_public_path__ + "static/media/Step_1.a8e349bc90520974ed03528051282a93.svg";
export { ForwardRef as ReactComponent };